/**
 * 添加店铺搜索项
 *  @param  type  String  使用的option 的key
 */
import { mapState } from 'vuex';

// eslint-disable-next-line
export default function (type) {
    return {
        computed: {
            ...mapState('user', [
                'userInfo',
                'orgList',
                'groupOrgList',
            ]),
        },
        created() {
            // 多店版 店铺搜索的值取orgList
            if (this.userInfo.mode === 2) {
                const options = this.orgList;
                const multipleProps = {
                    type: 'select',
                    label: '店铺名称',
                    field: 'orgIds',
                    options,
                    attrs: {
                        clearable: true,
                        filterable: true,
                        multiple: true,
                        'collapse-tags': true,
                    },
                };
                if (type) this[type].push(multipleProps);
                else this.props.options.push(multipleProps);
            }
            // 集团版 店铺搜索
            // if (this.userInfo.mode === 3) {
            //     // 判断当前路由:默认是tag为store的list
            //     let options = this.orgList;
            //     // 用户和角色用全量的
            //     if (this.$route.name === 'RoleManageIndex' || this.$route.name === 'UserManageIndex') {
            //         options = this.groupOrgList;
            //     }

            //     const multipleProps = {
            //         type: 'select',
            //         label: '店铺名称',
            //         field: 'orgIds',
            //         options,
            //         attrs: {
            //             clearable: true,
            //             filterable: true,
            //             multiple: true,
            //             'collapse-tags': true,
            //         },
            //     };
            //     if (type) this[type].push(multipleProps);
            //     else this.props.options.push(multipleProps);
            // }
        },
        methods: {
            /**
             * 判端集团版的按钮是否展示，只在操作性质按钮上加】
             * 当用户最后一次登录的组织id为与当前用户列表中的用户对应的组织id相同时显示
             * 否则不显示
             *  @param type orgId
             * @return type Boolean
             * true：显示
             * false：不显示
             */
            corpotationBtnVisible() {
                return true;
                // if (this.userInfo.mode === 3) {
                //     if (orgId === this.userInfo.lastLoginOrgId) return true;
                //     return false;
                // }
                // return true;
            },

        },

    };
}
